import AnnouncementsIndex from './AnnouncementsIndex';
import AnnouncementsCreate from './AnnouncementsCreate';
import AnnouncementsSettings from './AnnouncementsSettings';
import AnnouncementsSingle from './AnnouncementsSingle';

export default function (app) {

    const settings = AnnouncementsSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    AnnouncementsIndex(app, settings);

    AnnouncementsCreate(app, settings);

    AnnouncementsSingle(app, settings);

}